import React, { useState } from 'react';
import { useTheme } from '@emotion/react';
// Mui components
import { Box, Typography, Chip } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
// Hooks
import { formatearEspecialidad, toCamelCaseAllWords } from '../../../utils/Hooks/textFormatted';

export default function SelectorEspecialidades({
  selectedEspecializaciones,
  setSelectedEspecializaciones,
  especialidades,
  setCambiosRealizados
}) {
  const theme = useTheme();

  const [initialStatesSpecialty] = useState(especialidades);

  const handleCheckboxChange = (especialidad) => {
    const updatedEspecializaciones = selectedEspecializaciones.map((item) =>
      item.codigoOsde === especialidad.codigoOsde ? { ...item, solicitada: !item.solicitada } : item
    );
    setSelectedEspecializaciones(updatedEspecializaciones);

    const changesMade =
      JSON.stringify(updatedEspecializaciones) !== JSON.stringify(initialStatesSpecialty);
    setCambiosRealizados(changesMade);
  };

  const getMessage = (especialidad) => {
    const initialState = initialStatesSpecialty.find(
      (esp) => esp.codigoOsde === especialidad.codigoOsde
    );

    if (initialState.solicitada === true && especialidad.solicitada === false) {
      return (
        <Chip
          sx={{
            borderRadius: '8px',
            padding: '6px 8px',
            backgroundColor: '#E7E9F7'
          }}
          label={
            <Typography variant="list" color={theme.palette.primary.main}>
              {message.modificadoBaja}
            </Typography>
          }
        />
      );
    }
    if (initialState.solicitada === false && especialidad.solicitada === true) {
      return (
        <Chip
          sx={{
            borderRadius: '8px',
            padding: '6px 8px'
          }}
          label={
            <Typography variant="list" color={theme.palette.primary.main}>
              {message.modificadoAlta}
            </Typography>
          }
          color="white"
        />
      );
    }
    if (initialState.solicitada === true && especialidad.solicitada === true) {
      return (
        <Chip
          sx={{
            borderRadius: '8px',
            padding: '6px 8px'
          }}
          label={
            <Typography variant="list" color={theme.palette.primary.main}>
              {message.sinModificarAlta}
            </Typography>
          }
          color="white"
        />
      );
    }
  };

  const message = {
    modificadoBaja: 'Desconectar turnos',
    modificadoAlta: 'Conectar turnos',
    sinModificarAlta: 'Publicada'
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          maxHeight: selectedEspecializaciones.length > 4 ? '312px' : 'auto',
          overflowY: selectedEspecializaciones.length > 4 ? 'auto' : 'unset'
        }}>
        {selectedEspecializaciones.map((especialidad, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              padding: '16px',
              gap: '8px',
              height: '56px',
              border: `2px solid ${theme.palette.backgroundSecondary.main}`,
              borderRadius: '1rem',
              justifyContent: 'space-between',
              backgroundColor: especialidad.solicitada
                ? theme.palette.backgroundSecondary.main
                : theme.palette.white.main
            }}>
            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={especialidad.solicitada}
                    onChange={() => handleCheckboxChange(especialidad)}
                  />
                }
                label={
                  <Typography variant="list">
                    {toCamelCaseAllWords(formatearEspecialidad(especialidad.descripcion))}
                  </Typography>
                }
                key={especialidad.descripcion}
              />
            </Box>

            <Box sx={{ display: 'flex', height: '100%', alignItems: 'center' }}>
              {getMessage(especialidad)}{' '}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
